/* Copyright (C) Okahu Inc 2023-2024. All rights reserved.*/

'use client';

import { UserProvider } from '@auth0/nextjs-auth0/client';

// simple_token and entra_id have no Auth0 session, so UserProvider must never
// hit /api/auth/me for them - that route 404s (and would otherwise require
// AUTH0_SECRET) when AUTH_PROVIDER isn't auth0. The fetcher must be built here
// (client component) since functions can't be passed from a server component.
const noAuth0SessionFetcher = async () => undefined;

type AppUserProviderProps = Readonly<{
  usesAuth0Session: boolean;
  children: React.ReactNode;
}>;

export const AppUserProvider = ({
  usesAuth0Session,
  children,
}: AppUserProviderProps) => (
  <UserProvider fetcher={usesAuth0Session ? undefined : noAuth0SessionFetcher}>
    {children}
  </UserProvider>
);
